import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {TranslateDirective, TranslatePipe} from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
    selector: 'que-send-success',
    imports: [CommonModule, TranslateDirective, TranslatePipe, SvgIconComponent],
    templateUrl: './send-success.component.html',
    styleUrls: ['./send-success.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SendSuccessComponent {
  constructor(private readonly dialogRef: MatDialogRef<SendSuccessComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    dialogRef.disableClose = true;
  }
  close() {
    this.dialogRef.close();
  }
  back() {
    this.dialogRef.close("back");
  }
}
